import React, { useEffect, useState, useContext } from "react";
import PropTypes from "prop-types";
import { useMsal } from "@azure/msal-react";
import PrimarySelect from "../../../Inputs/PrimarySelect/PrimarySelect";
import { nullCheck } from "../../../../utils/dataHelpers";
import { SecurityService } from "../../../../services/SecurityService";
import { AlertContext } from "../../../Dashboard/Dashboard";

export default function UserRoleCell({cell, row, column, updateData}) {
  const { instance } = useMsal();
  const [selectedRoleId, setSelectedRoleId] = useState("");

  const roles = nullCheck(cell, [], "row", "original", "roles");
  const user = nullCheck(cell, {}, "row", "original");

  const { warning } = useContext(AlertContext);

  useEffect(() => {
    if (user && user.role) {
      setSelectedRoleId(user.role.roleId);
    }
  }, [cell]);

  const updateUserRole = (roleId, role) => {
    const updatedUser = {...user};
    updatedUser.roleId = roleId;
    updatedUser.role = role;
    delete updatedUser.roles;

    SecurityService.UpdateUser(instance, updatedUser).catch(error => {
      console.error(error);
      warning(error);
    });
  };
  
  const handleRoleChange = (r) => {
    const role = user.roles.find( ({roleId}) => roleId === r);
    setSelectedRoleId(r);
    updateUserRole(r, role);
    updateData(row.index, column.id, role);
  };

  return (
    <span style={{display: "flex", alignItems: "center"}}>
      <PrimarySelect 
        options={roles}
        onChange={r => handleRoleChange(r)}
        value={selectedRoleId} 
        width="160px"
        variant="standard"
        nameKey="roleName"
        valueKey="roleId"
        disabled={!user.isActive}
      />
    </span>
  );
}

UserRoleCell.propTypes = {
  cell: PropTypes.object,
  row: PropTypes.object,
  column: PropTypes.object,
  updateData: PropTypes.func
};